import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && typeof honeypot === 'string' && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9snjlt8o1vn02ekuihg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email } as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们已收到您的邮箱，将定期为您推送风月美学内容。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '订阅失败，请稍后重试';
        if (serverMsg.toLowerCase().includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('订阅失败，请稍后重试');
        } else {
          setStatus('error');
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后重试');
    }
  };

  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Misty%20Chinese%20mountain%20landscape%20at%20dawn%2C%20layers%20of%20blue%20green%20peaks%20fading%20into%20distance%2C%20soft%20golden%20morning%20light%2C%20traditional%20pavilion%20silhouette%20on%20cliff%2C%20ethereal%20clouds%2C%20ink%20wash%20painting%20style%2C%20dreamy%20poetic%20atmosphere%2C%20wide%20panoramic%20view&width=1920&height=600&seq=newsletter-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-foreground-900/75" />

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <p className="text-accent-300 font-heading text-sm tracking-[0.2em] mb-3">风月来信</p>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
          订阅风月美学通讯
        </h2>
        <p className="text-white/70 text-sm leading-relaxed mb-8">
          每周精选风月文化、生活美学与诗意灵感，第一时间送达您的邮箱。
          让风月之美，常伴左右。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="wf-required"
          />
          <input
            type="email"
            name="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            className="flex-1 px-5 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/40 text-sm focus:outline-none focus:border-accent-400 transition-colors"
          />
          <button
            type="submit"
            className="whitespace-nowrap px-8 py-3 bg-accent-500 hover:bg-accent-600 text-foreground-950 font-medium rounded-full transition-all duration-300 text-sm"
          >
            立即订阅
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-300' : 'text-red-300'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}